import { QdzElement, define } from '@qdz/element';

const HOVER_QUERY = window.matchMedia('(hover: hover) and (pointer: fine)');

export class QdzDisclosure extends QdzElement {
  #leaveTimer = null;
  #openedByHover = false;

  get details() {
    return this.querySelector(':scope > details');
  }

  get summary() {
    return this.details?.querySelector(':scope > summary');
  }

  mount() {
    if (!this.details) return;
    this.listen(this, 'keydown', (event) => {
      if (event.key !== 'Escape' || !this.details.open) return;
      event.stopPropagation();
      this.close();
      this.summary.focus();
    });
    this.listen(this, 'focusout', (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
    });
    this.listen(document, 'click', (event) => {
      if (this.details.open && !this.contains(event.target)) this.close();
    });
    this.listen(this.details, 'toggle', () => this.#sync());
    if (this.hasAttribute('hover')) {
      this.listen(this, 'pointerenter', () => this.#hover(true));
      this.listen(this, 'pointerleave', () => this.#hover(false));
      this.listen(this.summary, 'click', (event) => {
        if (!this.#openedByHover) return;
        event.preventDefault();
        this.#openedByHover = false;
      });
    }
    this.#sync();
  }

  unmount() {
    clearTimeout(this.#leaveTimer);
  }

  open() {
    this.details.open = true;
  }

  close() {
    this.details.open = false;
  }

  editorSelect(event) {
    if (this.contains(event.target)) this.open();
  }

  editorDeselect() {
    this.close();
  }

  #hover(entering) {
    if (!HOVER_QUERY.matches) return;
    clearTimeout(this.#leaveTimer);
    if (entering) {
      this.#openedByHover = !this.details.open;
      this.open();
    } else {
      this.#leaveTimer = setTimeout(() => this.close(), 150);
    }
  }

  #sync() {
    if (!this.details.open) this.#openedByHover = false;
    this.summary?.setAttribute('aria-expanded', String(this.details.open));
    if (this.details.open) this.emit('disclosure:open');
  }
}

define('qdz-disclosure', QdzDisclosure);
